import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "q-pl-sm",
    style: { "text-transform": "none !important" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_inner_loading = _resolveComponent("q-inner-loading");
    const _component_q_btn = _resolveComponent("q-btn");
    return (_openBlock(), _createBlock(_component_q_btn, {
        icon: "img:https://dminqct125wnz.cloudfront.net/common/logos/google.png",
        "no-caps": "",
        onClick: _ctx.login,
        disable: _ctx.disable || !_ctx.googleReady || !_ctx.ready,
        class: "full-width"
    }, {
        default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label || 'Sign in with Google'), 1),
            _createVNode(_component_q_inner_loading, {
                showing: !_ctx.googleReady,
                class: "text-accent"
            }, null, 8, ["showing"])
        ]),
        _: 1
    }, 8, ["onClick", "disable"]));
}
